 <template>
  <div
    class="transactions-dashboard clickable"
    v-tooltip="$t('section_transaction_hover')"
    @click="navigateToExpenses"
  >
    <template v-if="!isCallingTransactionDashboard">
      <div class="transactions-dashboard--header">
        <h2
          class="transaction-dashboard-title"
          v-t="{path:'transactions_dashboard_transactions_header'}"
        ></h2>
        <h2
          class="transaction-dashboard-title"
          v-t="{path:'transactions_dashboard_total_spent_header'}"
        ></h2>
      </div>
      <div
        class="transactions-dashboard--row"
        v-if="!errorFlag"
      >
        <span class="field-data">{{totalTransactions}}</span>
        <span class="field-data">{{totalSpentInTransactions | currency('€', 2, {
              symbolOnLeft: false,
              thousandsSeparator: '.',
              decimalSeparator: ','
            })}}</span>
      </div>
      <div
        class="transactions-dashboard--row"
        v-else
      >
        <span class="field-data--error text-danger">No se han podido obtener los datos</span>
      </div>
    </template>
    <div
      class="d-flex justify-content-center w-100"
      v-else
    >
      <spinner />
    </div>

  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'TransactionsDashboard',
  data () {
    return {
      isCallingTransactionDashboard: false,
      errorFlag: false
    }
  },
  components: { Spinner },
  computed: {
    totalTransactions () {
      return this.$store.getters['TransactionsStore/topBanner'] ? this.$store.getters['TransactionsStore/topBanner'].totalCount : ''
    },
    totalSpentInTransactions () {
      return this.$store.getters['TransactionsStore/topBanner'] ? this.$store.getters['TransactionsStore/topBanner'].totalAmount : ''
    },
    currentMonthFirstDay () {
      return this.$moment.utc().startOf('month').format()
    },
    currentMonthLastDay () {
      return this.$moment.utc().endOf('month').format()
    }
  },
  methods: {
    async fetchTopBanner () {
      if (this.isCallingTransactionDashboard) return
      this.isCallingTransactionDashboard = true
      try {
        const filters = {
          'date[after]': this.currentMonthFirstDay,
          'date[before]': this.currentMonthLastDay,
          'status.code': ['OK', 'PENDING'],
          'amountDistinctZero': true
        }
        await this.$store.dispatch('TransactionsStore/fetchTopBanner', filters)
      } catch (error) {
        this.errorFlag = true
      } finally {
        this.isCallingTransactionDashboard = false
      }
    },
    navigateToExpenses () {
      const expensesRoute = '/expenses/transactions/charged'
      if (this.$route.path !== expensesRoute) {
        this.$router.push({ name: 'my_charged_transactions' })
      }
    }

  },
  async created () {
    await this.fetchTopBanner()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/transactions/transactions-dashboard.scss";
</style>

<style scoped>
.transaction-dashboard-title {
  font-size: 15px;
  color: var(--text-heading);
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 0;
}

.field-data {
  font-weight: 600;
  font-size: 15px;
  color: var(--gray);
}

@media screen and (max-width: 576px) {
  .transactions-dashboard {
    display: none;
  }
}

.transactions-dashboard {
  position: fixed;
  right: 0;
  top:12px;
  bottom:6px;
  max-width: 300px;
  width: 100%;
  margin: 0 10px 0;
  height:fit-content;

}

.transactions-dashboard--header,
.transactions-dashboard--row {
  display: grid;
  grid-template-columns: minmax(130px, 150px) minmax(130px, 150px);
  grid-gap: 15px;
}
.field-data--error {
  grid-template-columns: 1fr;
}
</style>
